import { render, staticRenderFns } from "./VisaLogo.vue?vue&type=template&id=b0d6cebc&scoped=true&"
var script = {}
import style0 from "./VisaLogo.vue?vue&type=style&index=0&id=b0d6cebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d6cebc",
  null
  
)

export default component.exports